const DOMIdentifier = {
  addClassToBody: (templateIdent = '', pageIdent = '') => {
    try {
      if (typeof document != 'undefined') {
        let body = document.body;
        if (templateIdent.length) body.classList.add(templateIdent);
        if (pageIdent.length) body.classList.add(pageIdent);
      }
    } catch (err) {
      /* console.warn('Identifier injection failed at DOM body');*/
    }
  },
  removeClassToBody: (templateIdent = '', pageIdent = '') => {
    try {
      if (typeof document != 'undefined') {
        let body = document.body;
        if (templateIdent.length) body.classList.remove(templateIdent);
        if (pageIdent.length) body.classList.remove(pageIdent);
      }
    } catch (err) {
      /* console.warn('Identifier remove failed at DOM body'); */
    }
  },
};

export default DOMIdentifier;
